import { AutogenModelHubtranInvoiceExceptions, AutogenRowHubtranInvoiceExceptions } from "./autogen/AutogenModelHubtranInvoiceExceptions";

export class ModelHubtranInvoiceExceptions extends AutogenModelHubtranInvoiceExceptions<RowHubtranInvoiceExceptions> {
	constructor() {
		super(RowHubtranInvoiceExceptions);
	}
}

export class RowHubtranInvoiceExceptions extends AutogenRowHubtranInvoiceExceptions {
}